import { useField } from "formik";
import SelectablePill from "components/SelectablePill";

const FormikSelectablePill = ({ name, ...rest }) => {
  const [field, meta, helpers] = useField({ name });

  const handleChange = (option) => {
    helpers.setValue(option.value);
  };

  return (
    <SelectablePill {...rest} {...field} {...meta} onChange={handleChange} />
  );
};

export default FormikSelectablePill;
